import { ref } from "@vue/composition-api";
import providers from "@/lib/api";
import config from "@/config";

export default function useAppointments() {
  const isBookingAvailable = ref(false);

  const checkBookingAvailable = async (userId: string) => {
    if (!config.featureAppointments) return;
    const response = await providers.AppointmentTypeProvider.search({
      data: { userIds: [userId] },
    });
    isBookingAvailable.value = response[0].types.length > 0;
  };

  return {
    isBookingAvailable,
    checkBookingAvailable,
  };
}
